import jwtDecode from 'jwt-decode'
import Cookies from 'js-cookie'

const storageKey = 'CampAccessToken'

const getAuth = () => {
  const auth = Cookies.getJSON(storageKey)
  return auth
}

const getAuthDecode = () => {
  const auth = Cookies.getJSON(storageKey)
  return auth ? jwtDecode(auth) : null
}

const setAuthUser = (token) => {
  const date = jwtDecode(token).exp * 1000
  Cookies.set(storageKey, token, { expires: new Date(date) })
}

const clearAuth = () => {
  Cookies.remove(storageKey)
}

const getAuthToken = () => ({
  key: 'Authorization',
  value: `Bearer ${ Cookies.getJSON(storageKey) || '' }`
})

export default {
  setAuthUser,
  getAuth,
  getAuthToken,
  clearAuth,
  getAuthDecode
}

export {
  setAuthUser,
  getAuth,
  getAuthToken,
  clearAuth,
  getAuthDecode
}
